/*
 * Do not update this file manually.
 * It is automatically generated from /scripts/generate-contentful-types.ts
 */
import type {
    ChainModifiers,
    Entry,
    EntryFieldTypes,
    EntrySkeletonType,
    LocaleCode,
} from 'contentful'

export interface TypeTdCustomPageQuoteFields {
    text: EntryFieldTypes.Symbol
    author: EntryFieldTypes.Symbol
    role?: EntryFieldTypes.Symbol
    avatar?: EntryFieldTypes.AssetLink
}

export type TypeTdCustomPageQuoteSkeleton = EntrySkeletonType<
    TypeTdCustomPageQuoteFields,
    'tdCustomPageQuote'
>
export type TypeTdCustomPageQuote<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeTdCustomPageQuoteSkeleton, Modifiers, Locales>

export function isTypeTdCustomPageQuote<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode,
>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeTdCustomPageQuote<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'tdCustomPageQuote'
}
